import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6535 2.3424C10.5305 -0.780799 5.46674 -0.780799 2.34355 2.3424C-0.303849 4.98979 -0.760449 9.12158 1.24055 12.2756L1.23935 12.2764C1.30175 12.375 1.32115 12.4996 1.28175 12.619L0.23395 15.762L3.34414 14.7252C3.46274 14.6744 3.60334 14.6812 3.72054 14.7554C8.98393 18.0936 15.9959 14.3376 15.9959 7.99739C15.9959 5.78899 15.1007 3.78939 13.6535 2.3424ZM7.80174 11.8786C6.66114 11.2554 4.38914 9.51138 3.85234 7.73779C2.96494 4.80559 5.52334 2.9452 7.99854 4.81899C10.4735 2.9452 13.0321 4.80539 12.1447 7.73779C11.6077 9.51258 9.32953 11.261 8.19154 11.8806C8.06534 11.9496 7.91854 11.9438 7.80174 11.8786Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }